export const getStrengthSetsFromWorkout = (workout = {}) =>
    (workout.blocks || [])
        .filter(block => (block.workoutType || "strength") === "strength")
        .flatMap(block => block.sets || []);

export const calculateStrengthVolumeByMuscle = (workout = {}) => {
    const volume = {};

    getStrengthSetsFromWorkout(workout).forEach(set => {
        const setsCount = Number(set.sets) || 0;
        if (setsCount <= 0) return;

        const muscles = set.primaryMuscles?.length
            ? set.primaryMuscles
            : [set.muscleGroup || "Não definido"];

        muscles.forEach(muscle => {
            volume[muscle] = (volume[muscle] || 0) + setsCount;
        });
    });

    return volume;
};

export const calculateStrengthWeeklyVolumeByMuscle = (workouts = []) =>
    workouts.reduce((acc, workout) => {
        const sessionVolume = calculateStrengthVolumeByMuscle(workout);
        Object.entries(sessionVolume).forEach(([muscle, count]) => {
            acc[muscle] = (acc[muscle] || 0) + count;
        });
        return acc;
    }, {});
